import { Component, OnInit, Inject, HostListener } from '@angular/core';
import { UiService } from '../../services/ui/ui.service';
import { light, dark } from '../../theme';
import { Router } from '@angular/router';
import { UserManagerService } from 'src/app/services/user-manager/user-manager.service';
import { MatDialog } from '@angular/material';
import { ResetPasswordComponent } from '../reset-password/reset-password.component';
import { Language } from 'src/app/interface/app-init.model';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  openProfileModal = false;
  date = new Date();
  user: any;
  selectLang = false;
  showProfile = false;
  languages: Array<Language>
  selectedLanguage: Language;
  constructor(public uiService: UiService,
              private router: Router,
              private userManager: UserManagerService,
              public dialog: MatDialog,
              private config: ConfigService) {
                this.languages = this.uiService.languagesOffered;
              }

  ngOnInit() {
    var configLang = this.config.lang;
    if(this.userManager.logindata.info && this.userManager.logindata.info.hasOwnProperty('lang')) {
      const lang = this.languages.find(item => item.code.toLowerCase() == this.userManager.logindata.info.lang.name.toLowerCase());
      if(lang){
        this.config.lang = lang.code;
        configLang = lang.code;
      }else {
        configLang = this.config.lang;
      }
    }
    this.selectedLanguage = this.languages.find(item => item.code == configLang.toLowerCase());

    this.user = {
      id: this.userManager.logindata.info ? this.userManager.logindata.info.id : '',
      name: this.userManager.logindata.info
            ? this.userManager.logindata.info.firstName + ' ' + this.userManager.logindata.info.lastName : '',
      username: this.userManager.logindata.info ? this.userManager.logindata.info.login : '',
      language: configLang
    }

    this.uiService.setDefaultLanguage(this.selectedLanguage.code.toLowerCase());
    setInterval(() => { this.setTime(); });
  }
  @HostListener('document:click', ['$event'])
  onDocumentClick(event) {
    if (!(event.target.parentNode.parentNode == document.getElementById("user"))) {
      this.showProfile = false;
    }
    if (!(event.target.parentNode == document.getElementById("lang"))) {
      this.selectLang = false;
    }
 };
  changePassword(){
    const dialogRef = this.dialog.open(ResetPasswordComponent, {
      maxWidth: '80%',
      panelClass: "scrollable",
      disableClose: true,
      data: {login: this.user.username}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // console.log(result);
      }
    });
  }
  selectlang() {
    this.selectLang = !this.selectLang;
  }
  showprofile() {
    this.showProfile = !this.showProfile;
  }
  toggleTheme() {
    if (this.uiService.theme.name === 'light') {
      this.uiService.theme = dark;
    } else if (this.uiService.theme.name === 'dark') {
      this.uiService.theme = light;
    }
    this.uiService.renderTheme();
  }

  setLanguageWithCode(langCode: string) {
    this.config.lang = langCode;
    this.uiService.setDefaultLanguage(langCode.toLowerCase());
  }

  setLanguage(language: Language) {
    this.selectedLanguage = language;
    this.uiService.setDefaultLanguage(language.code.toLowerCase());
    this.config.lang = language.code;
  }

  logout() {
    this.userManager.logoutAgent();   
  }

  private setTime() {
    this.date = new Date();
  }
}
